import React, { useRef } from 'react';
import {FaLinkedinIn, FaTwitter,FaGithub} from "react-icons/fa";
import {toast} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import emailjs from '@emailjs/browser'
import '../Styles/ContactUs.css'




 const Contact = () => {
  const form = useRef();

  const sendEmail = (e) => {
    emailjs.sendForm(process.env.REACT_APP_SERVICE_ID,process.env.REACT_APP_TEMPLATE_ID, form.current, process.env.REACT_APP_PUBLIC_KEY)
      .then((result) => {
        toast.success('🤗 Message Sent. I will be touch shortly. Thank you :)', {
          position: "top-center",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          });
          console.log(result.text);
          e.target.reset()
          e.preventDefault();
          console.log('clicked','success');
      }, (error) => {
          console.log(error.text);
      });
  };

  return (
  <section className = 'contact__container'>
    <div className = 'contact__wrapper'>
    <h1> Contact Me </h1>
    <form id='contact' ref={form} onSubmit={sendEmail}>
      <label> Name</label>
      <div>
      <input type="text" name="user_first" placeholder='Name' required/>
      </div>
      <div>
      <label> Email</label>
      <input type= "text" name="user_email" placeholder='Email' required/>
      </div>
      <div className = 'center'>
      <label> Message </label>
      <textarea name="message" rows='6' placeholder='Type Your Message Here' required></textarea>
      <div className='submit'>
      <input type="submit" value= "Send Message" />
      </div>
      <div className='socials'>
      <a href='https://www.linkedin.com/in/drummer5/' className='icon--contact'><FaLinkedinIn/></a> 
      <a href='https://Twitter.com/drummerbrown5'className='icon--contact'><FaTwitter/></a>
      <a href='https://github.com/DrummerDee/DrummerDee'className='icon--contact'><FaGithub/></a>
    </div>
      </div>
    </form>
  </div>
  </section>

  );
};

export default Contact;